import { IConfig } from '@vivli/shared/infrastructure/interface';
import { Configuration, LogLevel } from '@azure/msal-browser';
import { LoggerService } from '@vivli/shared/infrastructure/service';
import { useB2CAuthority } from './use-b2c-authority.hook';

export const useMsalConfig = (config: IConfig): Configuration => {
    const authority = useB2CAuthority(config);

    let portDelimAndNumber = `:${window.location.port}`;
    portDelimAndNumber = portDelimAndNumber === ':' ? '' : portDelimAndNumber;

    const redirectUri = `${window.location.protocol}//${window.location.hostname}${portDelimAndNumber}`;
    const postLogoutRedirectUri = `${window.location.protocol}//${window.location.hostname}${portDelimAndNumber}`;

    const msalConfig: Configuration = {
        auth: {
            clientId: config?.b2CAppId,
            authority,
            redirectUri,
            postLogoutRedirectUri,
            knownAuthorities: [authority]
        },
        cache: {
            cacheLocation: 'localStorage'
        },
        system: {
            loggerOptions: {
                loggerCallback: (level, message, containsPii) => {
                    if (containsPii) {
                        return;
                    }
                    switch (level) {
                        case LogLevel.Error:
                            LoggerService.error(message);
                            return;
                        case LogLevel.Info:
                            LoggerService.info(message);
                            return;
                        case LogLevel.Verbose:
                            LoggerService.debug(message);
                            return;
                        case LogLevel.Warning:
                            LoggerService.warn(message);
                            return;
                    }
                },
                piiLoggingEnabled: false
            },
            windowHashTimeout: 60000,
            iframeHashTimeout: 6000,
            loadFrameTimeout: 0
        }
    };

    return msalConfig;
};
